import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const useLoadingMessages = (isLoading: boolean) => {
	const { t } = useTranslation();
	const [message, setMessage] = useState(t("sessionConfig.start"));

	useEffect(() => {
		if (!isLoading) {
			setMessage(t("sessionConfig.start"));
			return;
		}

		setMessage(t("sessionConfig.configuringSession"));

		const messages = [
			t("sessionConfig.fetchingContent"),
			t("sessionConfig.preparingMaterials"),
			t("sessionConfig.almostThere"),
			t("sessionConfig.startingSession"),
		];
		let index = 0;

		const intervalId = setInterval(() => {
			setMessage(messages[index]);
			index = (index + 1) % messages.length;
		}, 2000);

		return () => clearInterval(intervalId);
	}, [isLoading, t]);

	return message;
};

export default useLoadingMessages;
